import {
    forwardRef,
    InputHTMLAttributes,
    MutableRefObject,
    TdHTMLAttributes,
} from 'react';
import {twMerge} from 'tailwind-merge';

export const TableStaticCheckbox = forwardRef<HTMLInputElement>(
    (props, ref) => <input {...props} ref={ref} type="checkbox" />,
);
TableStaticCheckbox.displayName = 'TableStaticCheckbox';

type TableStaticCheckboxCellProps = {
    inputProps?: InputHTMLAttributes<HTMLInputElement>;
} & TdHTMLAttributes<HTMLTableDataCellElement>;

export const TableStaticCheckboxCell = forwardRef<
    HTMLTableCellElement,
    TableStaticCheckboxCellProps
>(({inputProps, ...gridCellProps}, ref) => (
    <td ref={ref} {...gridCellProps}>
        <TableStaticCheckbox {...inputProps} />
    </td>
));

TableStaticCheckboxCell.displayName = 'TableStaticCheckboxCell';

type TableStaticSelectAllCellProps = {
    checkboxRef?: MutableRefObject<null>;
    className?: string;
    inputProps?: InputHTMLAttributes<HTMLInputElement>;
};

export const TableStaticSelectAllCell = forwardRef<
    HTMLTableCellElement,
    TableStaticSelectAllCellProps
>(({checkboxRef, className, inputProps, ...headerProps}, ref) => (
    <th className={twMerge('w-8', className)} ref={ref} {...headerProps}>
        <TableStaticCheckbox ref={checkboxRef} {...inputProps} />
    </th>
));

TableStaticSelectAllCell.displayName = 'TableStaticSelectAllCell';
